declare global {
	interface Window {
		__REACT_MODAL_EXIT_CALLBACK?: Promise<void> | (() => void);
	}
}

export function modalExitedCallback(callback: () => void) {
	window.__REACT_MODAL_EXIT_CALLBACK = callback;
}

export function _executeOnExitedCallbackAndCleanUp() {
	if (typeof window.__REACT_MODAL_EXIT_CALLBACK === 'function') {
		window.__REACT_MODAL_EXIT_CALLBACK();
		delete window.__REACT_MODAL_EXIT_CALLBACK;

		return;
	}

	if (
		typeof window.__REACT_MODAL_EXIT_CALLBACK === 'object' &&
		typeof window.__REACT_MODAL_EXIT_CALLBACK['then'] === 'function'
	) {
		window.__REACT_MODAL_EXIT_CALLBACK.then(() => {
			delete window.__REACT_MODAL_EXIT_CALLBACK;
		});
	}
}

const IS_OPEN_MODAL_BODY_CLASS = 'react-modal-is-open';

export const modalBoxUtils = {
	addClassForBody: () => {
		document.body.classList.add(IS_OPEN_MODAL_BODY_CLASS);
	},
	removeClassForBody: () => {
		document.body.classList.remove(IS_OPEN_MODAL_BODY_CLASS);

		// Fix for old platform - removing jump effect for sidebar.
		const sidebar = document.querySelector('.js--sidebar--expand') as HTMLElement;

		if (sidebar) {
			sidebar.style.right = '0px';
		}
	},
	offsetTop: () => {
		return Math.abs(parseInt(document.documentElement.style.top, 10));
	},
	isOpen: () => {
		return document.body.classList.contains(IS_OPEN_MODAL_BODY_CLASS);
	},
};
